import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';

import FlowTitleSEO from '../../../ui/v2/flow-title';
import PageTitleSEO from '../../../ui/v2/typography/page-title';
import PartPreview from '../part-preview';
import { SearchCategoryName } from '../../v2/vehicle/utils/get-category-by-slug';
import { useAppContext } from '../../../providers/app-context';
import SetAlertInfo from '../../v2/create-part-alert/index_new';

type BrandTitleProps = {
  hasSelection: any;
  groups: Array<TCategory>;
  selection: { category: TCategorySelection };
  total_products: string;
  info: SearchCategoryName;
};

const BrandTitle = ({
  hasSelection,
  groups,
  selection,
  total_products,
  info,
}: BrandTitleProps) => {
  const { t } = useTranslation();
  const { businessValues } = useAppContext();
  const subCategoryPlural = `parts-and-categories-plural:parts.${selection?.category.category}.${info?.subCategoryEnPart}`;
  return (
    <FlowTitleSEO
      cols={[
        <PageTitleSEO
          key={'title'}
          title={
            selection?.category
              ? t('common:brand.pageTitleWithCategory', {
                count: total_products,
                usedWord:
                  info?.subCategoryType && info?.subCategoryType === 'F'
                    ? t('grammar:words.used.feminine')
                    : t('grammar:words.used.masculine'),
                plural: info?.subCategoryEnPart
                  ? t(
                    subCategoryPlural,
                    {},
                    {
                      fallback: info?.subCategory,
                    }
                  )
                  : info?.subCategory,
              })
              : t('common:brand.pageTitle')
          }
          categoryAndSubcategory={
            hasSelection && (
              <PartPreview groups={groups} selection={selection?.category} />
            )
          }
        />,
        <h2
          key="stock"
          className="max-w-[780px] text-center text-base lg:text-xl"
        >
          <Trans
            i18nKey={
              selection?.category
                ? 'common:brand.selectFromBrandStockWithPart'
                : 'common:selectFromStock'
            }
            components={{ strong: <strong /> }}
            values={{
              count: total_products || 4000000,
              part: info?.subCategory,
              usedWord:
                info?.subCategoryType && info?.subCategoryType === 'F'
                  ? t('grammar:words.used.feminine')
                  : t('grammar:words.used.masculine'),
              allWord:
                info?.subCategoryType && info?.subCategoryType === 'F'
                  ? t('grammar:pronnouns.all.feminine')
                  : t('grammar:pronnouns.all.masculine'),
              theWord:
                info?.subCategoryType && info?.subCategoryType === 'F'
                  ? t('grammar:pronnouns.the.feminine')
                  : t('grammar:pronnouns.the.masculine'),
              plural: info?.subCategoryEnPart
                ? t(
                  subCategoryPlural,
                  {},
                  {
                    fallback: info?.subCategory,
                  }
                )
                : info?.subCategory,
              totalStockAvailable:
                businessValues.totalStockAvailable.defaultValue,
            }}
          />
        </h2>,
        total_products && parseInt(total_products) <= 0 && (
          <div className="max-lg:text-center lg:mt-0">
            <SetAlertInfo
              part={info?.subCategory || selection || ''}
            />
          </div>
        ),
      ]}
    />
  );
};

export default BrandTitle;
